import React from "react";

import { Close as CloseIcon, Error as ErrorIcon } from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { makeStyles, withStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

type ModalProps = {
  visibility: boolean;
  onClose: () => void;
};
const useStyles = makeStyles()((theme) => ({
  root: {
    overflowY: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
  },
  modalBody: {
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(24, 24),
    backgroundColor: colors.white,
    overflowY: "auto",
    width: "470px",
  },
  modalHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    margin: theme.spacing(4, 3, 0, 3),
  },
  modalHeaderText: {
    fontSize: "28px",
    fontWeight: "bold",
  },
  titleText: {
    fontSize: "14px",
    fontWeight: 700,
    color: colors.dark,
    marginBottom: "20px",
  },
  form: {
    margin: theme.spacing(4, 3, 0, 3),
  },
  fields: {
    width: "100%",
  },
  fieldContainer: {
    marginBottom: "20px",
  },
  labelInfo: {
    color: colors.secondary,
    "& .MuiSvgIcon-root": {
      marginRight: "5px",
      marginTop: "4px",
    },
  },
  error: {
    fontSize: theme.typography.pxToRem(12),
  },
}));

const FieldLabel = withStyles(Typography, {
  root: {
    color: colors.gray,
    fontSize: "14px",
    marginBottom: "12px",
    "& label": {
      color: "#D13F3F",
    },
  },
});

type FormValues = {
  waterGoal: string;
};

const AddWaterGoalModal: React.FC<ModalProps> = ({ visibility, onClose }) => {
  const { classes } = useStyles();
  const { clientId, date } = useParams<{ clientId: string; date: string }>();

  const { control, handleSubmit } = useForm<FormValues>({
    defaultValues: {
      waterGoal: "",
    },
    mode: "onChange",
    reValidateMode: "onBlur",
  });

  const onSubmit: SubmitHandler<FormValues> = async (values) => {};

  return (
    <>
      <Modal open={visibility} onClose={onClose} className={classes.root}>
        <Box className={classes.modalBody}>
          <Box className={classes.modalHeader}>
            <Typography className={classes.modalHeaderText}>
              Add Water Goal
            </Typography>
            <IconButton onClick={onClose} size="large">
              <CloseIcon />
            </IconButton>
          </Box>
          <form
            className={classes.form}
            noValidate
            onSubmit={handleSubmit(onSubmit)}
          >
            <Box>
              <Box className={classes.fieldContainer}>
                <FieldLabel>Water Goal</FieldLabel>
                <Controller
                  name="waterGoal"
                  control={control}
                  render={({ field, fieldState: { error } }) => {
                    return (
                      <div>
                        <TextField
                          {...field}
                          className={classes.fields}
                          type="number"
                          placeholder="E.g. 2500 ml"
                        />

                        <Typography
                          variant="subtitle2"
                          color="error"
                          className={classes.error}
                        >
                          {error?.message}
                        </Typography>
                      </div>
                    );
                  }}
                />
                <Typography className={classes.labelInfo}>
                  <ErrorIcon fontSize="small" />
                  The goal will reflect on the profile&apos;s current water goal
                </Typography>
              </Box>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                marginBottom={4}
              >
                <Button color="primary" type="submit">
                  Save
                </Button>
              </Box>
            </Box>
          </form>
        </Box>
      </Modal>
    </>
  );
};

export default AddWaterGoalModal;
